"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageRequest = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = exports.EInfoRequestType = void 0;
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageTilemap_sidecar_1 = require("../tilemap/voyageTilemap-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
var voyageMessageInfoSend_sidecar_1 = require("./voyageMessageInfoSend-sidecar");
var EInfoRequestType;
(function (EInfoRequestType) {
    EInfoRequestType[EInfoRequestType["Crew"] = 0] = "Crew";
    EInfoRequestType[EInfoRequestType["System"] = 1] = "System";
})(EInfoRequestType = exports.EInfoRequestType || (exports.EInfoRequestType = {}));
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.InfoRequest;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write8(m, d.type);
    messageWriter_sidecar_1.messageWriter.write32(m, d.crewId);
    messageWriter_sidecar_1.messageWriter.write32(m, d.systemId);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        type: messageWriter_sidecar_1.messageWriter.read8(m),
        crewId: messageWriter_sidecar_1.messageWriter.read32(m),
        systemId: messageWriter_sidecar_1.messageWriter.read32(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        type: EInfoRequestType.Crew,
        crewId: 120,
        systemId: 123456,
    };
    messageWriter_sidecar_1.messageWriter.test('info-request', ex, write, read);
}
exports.test = test;
function process(m) {
    var msg = read(m);
    if (msg.type === EInfoRequestType.Crew) {
        var cr = diveCrew_sidecar_1.diveCrew.findById(msg.crewId);
        assert_sidecar_1.assert.notNil(cr);
        cr.requestedInfo = true;
        if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
            voyageMessageInfoSend_sidecar_1.voyageMessageInfoSend.sendMessageAndImmediatelyExecute({
                type: EInfoRequestType.Crew,
                crewId: msg.crewId,
                systemId: 0,
                name: cr.name,
                info1: cr.info1,
                title: cr.title,
            });
        }
    }
    if (msg.type === EInfoRequestType.System) {
        var sys = voyageTilemap_sidecar_1.voyageTilemap.getSystemByIdSafe(msg.systemId);
        assert_sidecar_1.assert.notNil(sys.system);
        sys.system.requestedInfo = true;
        if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
            voyageMessageInfoSend_sidecar_1.voyageMessageInfoSend.sendMessageAndImmediatelyExecute({
                type: EInfoRequestType.System,
                crewId: 0,
                systemId: sys.system.id,
                name: sys.system.nickname,
                info1: '',
                title: '',
            });
        }
    }
}
exports.process = process;
function sendMessageRequest(msg) {
    websockets_sidecar_1.websockets._sendMessageRequest(write, msg);
}
exports.sendMessageRequest = sendMessageRequest;
